export enum PaymentFrequency {
  MONTHLY = 'MONTHLY',
  YEARLY = 'YEARLY',
  QUARTERLY = 'QUARTERLY',
  SEMIANNUAL = 'SEMI_ANNUAL',
  BIMONTHLY = 'BI_MONTHLY',
}

export const getPaymentFrequencyLabel = (
  frequency: PaymentFrequency
): string => {
  switch (frequency) {
    case PaymentFrequency.MONTHLY:
      return $localize`Mensuel`;
    case PaymentFrequency.YEARLY:
      return $localize`Annuel`;
    case PaymentFrequency.QUARTERLY:
      return $localize`Trimestriel`;
    case PaymentFrequency.SEMIANNUAL:
      return $localize`Semestriel`;
    case PaymentFrequency.BIMONTHLY:
      return $localize`Bimestriel`;
    default:
      return frequency;
  }
};

export const BUSINESS_INSURANCE_PAYMENT_FREQUENCY = [
  PaymentFrequency.YEARLY,
  PaymentFrequency.SEMIANNUAL,
  PaymentFrequency.QUARTERLY,
];
